// extracted by mini-css-extract-plugin
module.exports = {"didYouMeanLink":"_30SCR"};